
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './components/Home';
import MoreGlassImages from './components/MoreGlassImages';
import Card01 from './Cards/Card01';
import Card02 from './Cards/Card02';
import Card03 from './Cards/Card03';
import Card04 from './Cards/Card04';
import Card05 from './Cards/Card05';
import Card06 from './Cards/Card06';
import Card07 from './Cards/Card07';
import Card08 from './Cards/Card08';
import Faqs from './components/Faqs';
import Careers from './components/Careers';
import Gallery from './components/Gallery';
import OurClients from './components/OurClients';
import Services from './components/Services';
import AllServices from './components/AllServices';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';

// import VisitCounter from "./VisitCounter";

function App() {
  return (
    <div className="App">

      {/* <Router> */}
        <Navbar/>
      
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/MoreGlassImages' element={<MoreGlassImages />} />
        <Route path='/Card01' element={<Card01 />} />
        <Route path='/Card02' element={<Card02 />} />
        <Route path='/Card03' element={<Card03 />} />
        <Route path='/Card04' element={<Card04 />} />
        <Route path='/Card05' element={<Card05 />} />
        <Route path='/Card06' element={<Card06 />} />
        <Route path='/Card07' element={<Card07 />} />
        <Route path='/Card08' element={<Card08 />} />

        <Route path='/Faqs' element={<Faqs />} />
        <Route path='/Careers' element={<Careers />} />
        <Route path='/Gallery' element={<Gallery />} />
        <Route path='/OurClients' element={<OurClients />} />
        <Route path='/AllServices' element={<AllServices />} />
        <Route path='/About' element={<About />} />
        <Route path='/Contact' element={<Contact />} />
      </Routes>

      <Footer />
      

      {/* </Router> */}
      
    </div>
  );
}

export default App;
